import React from "react";
import { EFootprint } from "../../../../Model/PlateType";
import { StorageConfig, HotelConfig } from "../../../../Model/StorageConfig";
import AccordionToggle from "../../../Plate/AccordionToggle";
import Collapse from "../../../Common/Collapse";
import { EModuleType } from "../../../../Model/EModuleType";
import { getModulesByType } from "../../../../redux/reducers/ModuleReducer";
import { getStorageConfig } from "../../../../redux/reducers/StorageConfigReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import SlotItemDisplay from "./SlotItemDisplay";
import {
  SlotAddress,
  SlotCorrectionResult,
} from "../../../../Model/SlotCorrection";
import "./SlotCorrection.css";
import {
  getPlateAddressesOnModule,
  getPlateAddresses,
} from "../../../../redux/reducers/PlateAddressReducer";
import { PlateAddress } from "../../../../Model/PlateAddress";
import { ESlotCorrectionStatus } from "../../../../Model/ESlotCorrectionStatus";

const getHotels = (storageConfig: StorageConfig) => {
  let hotels = [];
  for (let i = 0; i < storageConfig.hotels.length; i++) {
    hotels.push({
      id: i,
      name: `hotel-${EFootprint[storageConfig.hotels[i].footprint]}-${
        storageConfig.hotels[i].number
      }`,
      display: `Hotel ${EFootprint[storageConfig.hotels[i].footprint]} ${
        storageConfig.hotels[i].number
      }`,
    });
  }
  return hotels;
};

const isSlotOccupied = (plateAddress: PlateAddress | undefined) => {
  if (plateAddress === undefined) {
    return false;
  }

  if (plateAddress?.usedByPlate) {
    return true;
  }

  return false;
};

const isSlotError = (
  plateAddress: PlateAddress | undefined,
  correctionResults: SlotCorrectionResult[]
) => {
  if (plateAddress === undefined) {
    return true;
  }

  const currentSlotCorrection = correctionResults.find(
    (sc) =>
      sc.moduleIdentifier == plateAddress.moduleIdentifier &&
      sc.hotelNumber == plateAddress.hotelNo &&
      sc.slotNumber == plateAddress.slotNo &&
      sc.status == ESlotCorrectionStatus.Error
  );

  if (currentSlotCorrection !== undefined) {
    return true;
  }

  return false;
};

const getSlots = (
  hotelConfig: HotelConfig,
  plateAddresses: PlateAddress[],
  slotCorrectionResults: SlotCorrectionResult[]
) => {
  let slots = [];
  let disabledSlotsList: number[] | null =
    hotelConfig.disabledSlots == null
      ? null
      : hotelConfig.disabledSlots?.split(",").map(Number);
  if (hotelConfig !== undefined) {
    for (let i: number = 0; i < hotelConfig.capacity; i++) {
      let slotIndex: number = i + 1;
      const plateAddress = plateAddresses.find(
        (pa) => pa.hotelNo === hotelConfig.number && pa.slotNo == slotIndex
      );
      slots.push({
        id: i,
        name: `${hotelConfig.footprint}-${hotelConfig.number}-slot-${i}`,
        display: `Slot ${slotIndex}`,
        disabled:
          disabledSlotsList?.includes(slotIndex) ||
          isSlotOccupied(plateAddress) ||
          isSlotError(plateAddress, slotCorrectionResults),
      });
    }
  }
  return slots;
};

function getAccordionState(key: string): boolean[] {
  const value = localStorage.getItem(key);
  if (value != null) {
    return JSON.parse(value);
  } else {
    return [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
  }
}
export const HOTEL_ACCORDION_STATE = "HOTEL_ACCORDION_STATE";

type Prop = {
  selectAllChecked: string[];
  setSelectAllChecked: (value: string[]) => void;
  setSlotAddress: (value: SlotAddress[]) => void;
  slotAddress: SlotAddress[];
  moduleIdentifier: string;
  accordionState: boolean[];
  setAccordionState: (value: boolean[]) => void;
  slotCorrectionResults: SlotCorrectionResult[];
};

export default function AllSlotContent({
  selectAllChecked,
  setSelectAllChecked,
  setSlotAddress,
  slotAddress,
  moduleIdentifier,
  accordionState,
  setAccordionState,
  slotCorrectionResults,
}: Prop) {
  const storageModule = useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.CHAMBER][0]
  );
  const storageConfig = useTypedSelector((state) =>
    getStorageConfig(state, storageModule.identifier)
  );
  const hotels = getHotels(storageConfig);

  const plateAddresses = useTypedSelector((state) => getPlateAddresses(state));

  const onAccordionToggleClicked = (id: number) => {
    let state;
    state = [...accordionState];
    if (accordionState[id] === false) {
      state[id] = true;
    } else {
      state[id] = false;
    }
    setAccordionState(state);
  };
  return (
    <>
      {hotels.map((item) => {
        return (
          <div>
            <AccordionToggle
              style={{
                height: "48px",
                backgroundColor: "#FAFAFA",
                borderBottom: "1px solid #B4B4B4",
                color: "#313131",
                fontSize: "16px",
              }}
              expanded={accordionState[item.id]}
              onClick={() => {
                onAccordionToggleClicked(item.id);
              }}
              variant="secondary"
            >
              {item.display.replace(/^Hotel\s/, "")}
            </AccordionToggle>

            <Collapse expanded={accordionState[item.id]}>
              <SlotItemDisplay
                selectAllChecked={selectAllChecked}
                setSelectAllChecked={setSelectAllChecked}
                dataSlot={getSlots(
                  storageConfig.hotels[item.id],
                  plateAddresses.filter(
                    (pa) =>
                      pa.moduleIdentifier == storageConfig.moduleIdentifier
                  ),
                  slotCorrectionResults
                )}
                setSlotAddress={setSlotAddress}
                slotAddress={slotAddress}
                moduleIdentifier={moduleIdentifier}
                selectedHotelIndex={item.id}
              />
            </Collapse>
          </div>
        );
      })}
    </>
  );
}
